// extracted by mini-css-extract-plugin
export default {"container":"trends-side-menu_container__FrQ-O","show":"trends-side-menu_show__cB9+y","hide":"trends-side-menu_hide__b4dgR"};